export type FontSizePreference = "normal" | "large";

export const FONT_SIZE_STORAGE_KEY = "innergem_font_size";
export const FONT_SIZE_HTML_CLASS = "ig-font-large";

export function getFontSizePreference(): FontSizePreference {
  try {
    const raw = localStorage.getItem(FONT_SIZE_STORAGE_KEY);
    return raw === "large" ? "large" : "normal";
  } catch {
    return "normal";
  }
}

export function applyFontSizePreference(preference: FontSizePreference) {
  if (typeof document === "undefined") return;
  const htmlEl = document.documentElement;
  if (!htmlEl) return;

  if (preference === "large") {
    htmlEl.classList.add(FONT_SIZE_HTML_CLASS);
  } else {
    htmlEl.classList.remove(FONT_SIZE_HTML_CLASS);
  }
}

export function setFontSizePreference(preference: FontSizePreference) {
  try {
    localStorage.setItem(FONT_SIZE_STORAGE_KEY, preference);
  } catch {
    // ignore storage errors (private mode, quotas, etc.)
  }
  applyFontSizePreference(preference);
}
